// // src/lib/api.ts
// import axios from 'axios'

// export const API_BASE =
//   (typeof process !== 'undefined' && (process as any).env?.EXPO_PUBLIC_API) ||
//   (typeof window !== 'undefined' && (window as any).__API_BASE__) ||
//   'https://api.chindha.com'

// const api = axios.create({ baseURL: API_BASE, withCredentials: false })

// export function setAuthToken(token?: string) {
//   if (token) {
//     api.defaults.headers.common.Authorization = `Bearer ${token}`
//     try { localStorage.setItem('token', token) } catch {}
//   } else {
//     delete api.defaults.headers.common.Authorization
//     try { localStorage.removeItem('token') } catch {}
//   }
// }

// export function initAuthFromStorage() {
//   try {
//     const t = localStorage.getItem('token')
//     if (t) setAuthToken(t)
//   } catch {}
// }

// export default api

// src/lib/api.ts
import axios from 'axios'

export const API_BASE =
  (typeof process !== 'undefined' && (process as any).env?.EXPO_PUBLIC_API) ||
  (typeof window !== 'undefined' && (window as any).__API_BASE__) ||
  'https://api.chindha.com'

const api = axios.create({ baseURL: API_BASE, withCredentials: false })

// --- small event hub so App can react to global logout ---
export const AuthBus = {
  logout() {
    try {
      // clear token everywhere
      delete api.defaults.headers.common.Authorization
      try { localStorage.removeItem('token') } catch {}
    } catch {}
    // notify app
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('auth:logout'))
    }
  }
}

// --- helpers ---
function parseJwt(token?: string): any | null {
  if (!token) return null
  const parts = token.split('.')
  if (parts.length !== 3) return null
  try {
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
    return payload
  } catch { return null }
}

function isExpired(token?: string): boolean {
  const payload = parseJwt(token)
  if (!payload?.exp) return false
  const now = Math.floor(Date.now() / 1000)
  return payload.exp <= now
}

export function setAuthToken(token?: string) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`
    try { localStorage.setItem('token', token) } catch {}
  } else {
    delete api.defaults.headers.common.Authorization
    try { localStorage.removeItem('token') } catch {}
  }
}

export function initAuthFromStorage() {
  try {
    const t = localStorage.getItem('token')
    if (!t) return
    if (isExpired(t)) {
      // proactively log out stale tokens
      AuthBus.logout()
      return
    }
    setAuthToken(t)
  } catch {}
  return
}

// --- axios interceptor: auto logout on auth errors ---
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status
    const msg = String(err?.response?.data?.error || '').toLowerCase()
    // treat 401/403 and jwt expiration as logout triggers
    const shouldLogout =
      status === 401 ||
      status === 403 ||
      msg.includes('jwt expired') ||
      msg.includes('invalid token') ||
      msg.includes('unauthorized')

    if (shouldLogout) {
      AuthBus.logout()
    }
    return Promise.reject(err)
  }
)

export default api
